import React from "react";
import { AiOutlineDoubleLeft, AiOutlineClose } from "react-icons/ai";

const CartCount = ({ setShowCart, showCart, cartItems }) => {
  return (
    <div className="flex items-center justify-between bg-white p-2 sticky left-0 right-0 top-0">
      <div className="flex items-center gap-2">
        <div className="text-xl cursor-pointer hover:scale-125 transition-all duration-700 ease-in-out">
          <AiOutlineDoubleLeft onClick={() => setShowCart(!showCart)} />
        </div>
        <div className="flex gap-1 items-center">
          <h1 className="text-slate-800 text-sm font-bold">Cart Items :-</h1>
          <span className="text-sm font-semibold underline">
            {cartItems?.length}
          </span>
        </div>
      </div>
      <div
        onClick={() => setShowCart(!showCart)}
        className="text-xl cursor-pointer hover:scale-125 transition-all duration-700 ease-in-out flex items-center"
      >
        <AiOutlineClose className="rounded " />
      </div>
    </div>
  );
};

export default CartCount;
